export enum EntradaSaida {
  ENTRADA = "ENTRADA",
  SAIDA = "SAIDA",
}

export enum EntradaSaidaDescritivo {
  ENTRADA = "ENTRADA",
  SAIDA = "SAÍDA",
}

export enum SimNao {
  SIM = "SIM",
  NAO = "NAO",
}
